var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlankProfilePicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#D9EDFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 21.7777,
    r: 12.4444,
    fill: "#81C3FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3538 47.4328C47.5348 47.7325 47.4795 48.1164 47.225 48.3568C42.2097 53.0949 35.4441 55.9999 28 55.9999C20.5559 55.9999 13.7903 53.0949 8.77497 48.3568C8.52047 48.1164 8.46524 47.7325 8.6462 47.4328C12.2682 41.4335 19.5754 37.3333 28 37.3333C36.4246 37.3333 43.7318 41.4335 47.3538 47.4328Z",
    fill: "#81C3FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankProfilePicture);
export default __webpack_public_path__ + "static/media/blank-profile-picture.9d3796b4ee73d42727c2fdc1ecb2c1ff.svg";
export { ForwardRef as ReactComponent };